import { useCallback } from 'react';
import { useLocale } from '@hooks/useLocale';
const resolveLink = (pageType: string, locale: string, slug?: string) => {
  if (pageType === 'blogHome') {
    const blogSlug = slug ? `/${slug}` : '';
    return locale === 'fr' ? `/fr/blogue${blogSlug}` : `/en/blog${blogSlug}`;
  }

  return `/${locale}/`;
};

export const useLink = () => {
  const locale = useLocale();
  if (!locale)
    throw new Error(
      'Hook Error: useLink requires locale but locale is not set'
    );

  return useCallback(
    (pageType: string, slug?: string) => resolveLink(pageType, locale, slug),
    [locale]
  );
};
export default useLink;
